import React from 'react';
import PropTypes from 'prop-types';

import Alert from '@decisiv/ui-components/lib/components/Alert';
import Flex from '@decisiv/ui-components/lib/components/Flex';
import Modal from '@decisiv/ui-components/lib/components/Modal';
import { P } from '@decisiv/ui-components/lib/components/Typography';
import iconix from '@decisiv/iconix';

function RemoveRestoreModal({
  action,
  email,
  error,
  isSubmitting,
  isTerminal,
  onClose,
  onConfirm,
  account,
  username,
  visible,
}) {
  const isRemove = action === 'remove';
  const title = isRemove ? 'Remove Access' : 'Restore Access';
  const loadingText = isRemove ? 'Removing...' : 'Restoring...';
  const accountName = account?.name ?? '';

  return (
    <Modal
      actions={[
        {
          text: title,
          onClick: onConfirm,
          kind: 'primary',
          loading: isSubmitting,
          loadingText,
          disabled: isTerminal,
          ...(isRemove && { intent: 'danger' }),
        },
        {
          text: 'Cancel',
          onClick: onClose,
          kind: 'secondary',
          disabled: isSubmitting,
        },
      ]}
      intent={isRemove ? 'danger' : 'information'}
      icon={isRemove ? iconix.UserTimes : iconix.UserPlus}
      onClose={onClose}
      title={title}
      visible={visible}
    >
      <Flex flexDirection="column" justifyContent="center">
        <P>
          Clicking {title.toUpperCase()} will{' '}
          {isRemove ? 'prevent' : 'again grant'} <span>{username}</span> (email{' '}
          {email}) {isRemove ? 'from accessing' : 'access to'}{' '}
          <span>{accountName}</span>.
        </P>
        {isRemove && (
          <P>They will still have access to other accounts they belong to.</P>
        )}
        {error && (
          <div role="alert">
            <Alert
              intent="danger"
              title={isRemove ? 'Access not removed.' : 'Access not restored.'}
              description={error}
            />
          </div>
        )}
      </Flex>
    </Modal>
  );
}

RemoveRestoreModal.propTypes = {
  action: PropTypes.oneOf(['remove', 'restore']),
  email: PropTypes.string.isRequired,
  error: PropTypes.string,
  isSubmitting: PropTypes.bool,
  isTerminal: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  account: PropTypes.shape({ name: PropTypes.string }),
  username: PropTypes.string.isRequired,
  visible: PropTypes.bool,
};

RemoveRestoreModal.defaultProps = {
  action: null,
  error: null,
  isSubmitting: false,
  isTerminal: false,
  account: null,
  visible: false,
};

export default RemoveRestoreModal;
